/**
 * @generated SignedSource<<e5ee87e61dd1b736034ab5d86d7277cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RepeatTypeEnum = "daily" | "monthly" | "weekly" | "%future added value";
export type PromotionUpdateInput = {
  endAt?: any | null;
  id: string;
  isRepeat?: boolean | null;
  priority?: number | null;
  query?: string | null;
  repeatType?: RepeatTypeEnum | null;
  repeatValue?: string | null;
  startAt?: any | null;
  title?: string | null;
};
export type PromotionUpdateDialog_promotionUpdateMutation$variables = {
  input: PromotionUpdateInput;
};
export type PromotionUpdateDialog_promotionUpdateMutation$data = {
  readonly promotionUpdate: {
    readonly endAt: any;
    readonly id: string;
    readonly isRepeat: boolean;
    readonly nextOccurrences: ReadonlyArray<any>;
    readonly priority: number;
    readonly query: string | null;
    readonly repeatType: RepeatTypeEnum | null;
    readonly repeatValue: string | null;
    readonly startAt: any;
    readonly title: string;
  };
};
export type PromotionUpdateDialog_promotionUpdateMutation = {
  response: PromotionUpdateDialog_promotionUpdateMutation$data;
  variables: PromotionUpdateDialog_promotionUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Promotion",
    "kind": "LinkedField",
    "name": "promotionUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priority",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRepeat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "repeatType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "repeatValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "limit",
            "value": 1
          }
        ],
        "kind": "ScalarField",
        "name": "nextOccurrences",
        "storageKey": "nextOccurrences(limit:1)"
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionUpdateDialog_promotionUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionUpdateDialog_promotionUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3a5c8df3123ba270c13a892970dc7c4b",
    "id": null,
    "metadata": {},
    "name": "PromotionUpdateDialog_promotionUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionUpdateDialog_promotionUpdateMutation(\n  $input: PromotionUpdateInput!\n) {\n  promotionUpdate(input: $input) {\n    id\n    title\n    priority\n    startAt\n    endAt\n    isRepeat\n    repeatType\n    repeatValue\n    nextOccurrences(limit: 1)\n    query\n  }\n}\n"
  }
};
})();

(node as any).hash = "586833bdcec5bd1863312de0d114d491";

export default node;
